<script>
    import * as m from '@app/paraglide/messages.js';
    import { projectState } from '@app/store/projectStore.svelte.js'; 
    import { eventGroupState } from '@app/store/eventGroupStore.svelte.js'; 
    import { showModal } from '@app/store/modalStore.svelte.js';
    import EventGroupTab from './EventGroupTab.svelte';
    
    let draggedIndex = $state(null);
  
    function handleDragStart(e, index) {
      draggedIndex = index;
    }

    function handleDragOver(e) {
      e.preventDefault();
    }

    function handleDrop(e, dropIndex) {
      e.preventDefault();
      // Store the ID of the compared group if one exists
      let compareEventGroupId = projectState.compare !== false ? 
        eventGroupState[projectState.compare]?.id : false;

      // Save the moved item
      const movedItem = eventGroupState[draggedIndex];
      
      // Modify the array in place instead of reassigning
      // First remove the dragged item
      eventGroupState.splice(draggedIndex, 1);
      
      // Then insert it at the drop position
      eventGroupState.splice(dropIndex, 0, movedItem);
      
      // Update the selected index
      projectState.selected = dropIndex;
      
      // If we were comparing groups, find and update the new index of the compare group
      if (compareEventGroupId !== false && compareEventGroupId !== undefined && compareEventGroupId !== null) {
        let compareIndex = eventGroupState.findIndex(group => group.id === compareEventGroupId);
        projectState.compare = compareIndex;
      }
    }
</script>

<ul id="EventGroups" class="nav nav-tabs" role="tablist">
  <li class="nav-item">
    <button 
      id="addEventGroupBtn" 
      type="button" 
      class="btn btn-light rounded-bottom-0 border-0 bg-light h-100" 
      aria-label={m.editor_add_event_group()} 
      onclick={() => showModal("newEventGroup")}
    >
      <i class="bi bi-plus-circle-fill"></i>
    </button>
  </li>
  {#if eventGroupState.length > 0}
    {#each eventGroupState as eventGroup, index}
      <li
        role="presentation"
        class="nav-item {projectState.selected === index ? 'active' : ''}"
        draggable="true"
        ondragstart={(e) => handleDragStart(e, index)}
        ondragover={handleDragOver}
        ondrop={(e) => handleDrop(e, index)}
      >
        <EventGroupTab 
          name={eventGroup.name}
          eventGroupIndex={index}
          eventGroupType={eventGroup.type}
        />
      </li>
    {/each}
  {/if}
</ul>
  
<style lang="css">
  #EventGroups {
    overflow-x: scroll;
    overflow-y: hidden;
    flex-wrap: nowrap;
    display: -webkit-box;
  }
</style>